import BaseModel from '../core/BaseModel'
//import CategoriesModel from './CategoriesModel'
export default class ProductFromServicePackModel extends BaseModel {
    constructor() {
        super({ 
                name: "product_from_service_pack",
                tableName: 'core_product'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            model_code: {
                name: 'model_code', 
                type: "String", 
                label:'Model sản phẩm',
                width: 12,
                sortable: true,
                filter: { type: 'input', match: 'custom'}
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên sản phẩm',
                width: 18,
                sortable: true,
                filter: { type: 'input',  match: 'custom'}
            }
        },)
    }

}